/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as PrivateRouteImport } from './routes/_private'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ScanTagCodeRouteImport } from './routes/scan.$tagCode'
import { Route as AuthResetPasswordRequestRouteImport } from './routes/auth/reset-password-request'
import { Route as AuthResetPasswordConfirmRouteImport } from './routes/auth/reset-password-confirm'
import { Route as AuthResetPasswordRouteImport } from './routes/auth/reset-password'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as PrivateSettingsIndexRouteImport } from './routes/_private/settings/index'
import { Route as PrivateProjectsIndexRouteImport } from './routes/_private/projects/index'
import { Route as PrivateProjectsIdRouteImport } from './routes/_private/projects/$id'
import { Route as PrivateProjectsIdIndexRouteImport } from './routes/_private/projects/$id/index'
import { Route as PrivateProjectsIdDataRouteImport } from './routes/_private/projects/$id/data'
import { Route as PrivateProjectsIdDataIndexRouteImport } from './routes/_private/projects/$id/data/index'
import { Route as PrivateProjectsIdSitesNewRouteImport } from './routes/_private/projects/$id/sites.new'
import { Route as PrivateProjectsIdScanTagCodeRouteImport } from './routes/_private/projects/$id/scan.$tagCode'
import { Route as PrivateProjectsIdObservationsNewRouteImport } from './routes/_private/projects/$id/observations.new'
import { Route as PrivateProjectsIdGeospatialNewRouteImport } from './routes/_private/projects/$id/geospatial.new'
import { Route as PrivateProjectsIdDataUploadsRouteImport } from './routes/_private/projects/$id/data/uploads'
import { Route as PrivateProjectsIdObservationsNewIndexRouteImport } from './routes/_private/projects/$id/observations.new.index'
import { Route as PrivateProjectsIdDataTracksIndexRouteImport } from './routes/_private/projects/$id/data/tracks/index'
import { Route as PrivateProjectsIdDataTasksIndexRouteImport } from './routes/_private/projects/$id/data/tasks/index'
import { Route as PrivateProjectsIdDataSpeciesIndexRouteImport } from './routes/_private/projects/$id/data/species/index'
import { Route as PrivateProjectsIdDataSitesIndexRouteImport } from './routes/_private/projects/$id/data/sites/index'
import { Route as PrivateProjectsIdDataObservationsIndexRouteImport } from './routes/_private/projects/$id/data/observations/index'
import { Route as PrivateProjectsIdDataGeospatialIndexRouteImport } from './routes/_private/projects/$id/data/geospatial/index'
import { Route as PrivateProjectsIdDataContextIndexRouteImport } from './routes/_private/projects/$id/data/context/index'
import { Route as PrivateProjectsIdSitesSiteIdEditRouteImport } from './routes/_private/projects/$id/sites.$siteId.edit'
import { Route as PrivateProjectsIdObservationsNewSpeciesRouteImport } from './routes/_private/projects/$id/observations.new.species'
import { Route as PrivateProjectsIdObservationsNewExistingRouteImport } from './routes/_private/projects/$id/observations.new.existing'
import { Route as PrivateProjectsIdObservationsNewCollectionRouteImport } from './routes/_private/projects/$id/observations.new.collection'
import { Route as PrivateProjectsIdObservationsObservationIdEditRouteImport } from './routes/_private/projects/$id/observations.$observationId.edit'
import { Route as PrivateProjectsIdGeospatialRecordIdEditRouteImport } from './routes/_private/projects/$id/geospatial.$recordId.edit'
import { Route as PrivateProjectsIdDataTracksTrackIdRouteImport } from './routes/_private/projects/$id/data/tracks/$trackId'
import { Route as PrivateProjectsIdDataSpeciesSpeciesIdRouteImport } from './routes/_private/projects/$id/data/species/$speciesId'
import { Route as PrivateProjectsIdDataOfflineMapTilesRouteImport } from './routes/_private/projects/$id/data/offline/map-tiles'
import { Route as PrivateProjectsIdDataGeospatialRecordIdRouteImport } from './routes/_private/projects/$id/data/geospatial/$recordId'
import { Route as PrivateProjectsIdDataContextSourceIdRouteImport } from './routes/_private/projects/$id/data/context/$sourceId'
import { Route as PrivateProjectsIdDataSitesSiteIdIndexRouteImport } from './routes/_private/projects/$id/data/sites/$siteId/index'
import { Route as PrivateProjectsIdDataObservationsObservationIdIndexRouteImport } from './routes/_private/projects/$id/data/observations/$observationId/index'
import { Route as PrivateProjectsIdDataContextSpeciesTaxonRouteImport } from './routes/_private/projects/$id/data/context/species/$taxon'
import { Route as PrivateProjectsIdDataContextGovernmentLayerIdRouteImport } from './routes/_private/projects/$id/data/context/government/$layerId'
import { Route as PrivateProjectsIdDataContextDocumentDocumentIdRouteImport } from './routes/_private/projects/$id/data/context/document/$documentId'
import { Route as PrivateProjectsIdCollectionsCollectionIdDeterminationsNewRouteImport } from './routes/_private/projects/$id/collections.$collectionId.determinations.new'

const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivateRoute = PrivateRouteImport.update({
  id: '/_private',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ScanTagCodeRoute = ScanTagCodeRouteImport.update({
  id: '/scan/$tagCode',
  path: '/scan/$tagCode',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthResetPasswordRequestRoute =
  AuthResetPasswordRequestRouteImport.update({
    id: '/reset-password-request',
    path: '/reset-password-request',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthResetPasswordConfirmRoute =
  AuthResetPasswordConfirmRouteImport.update({
    id: '/reset-password-confirm',
    path: '/reset-password-confirm',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const PrivateSettingsIndexRoute = PrivateSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateProjectsIndexRoute = PrivateProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateProjectsIdRoute = PrivateProjectsIdRouteImport.update({
  id: '/projects/$id',
  path: '/projects/$id',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateProjectsIdIndexRoute = PrivateProjectsIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PrivateProjectsIdRoute,
} as any)
const PrivateProjectsIdDataRoute = PrivateProjectsIdDataRouteImport.update({
  id: '/data',
  path: '/data',
  getParentRoute: () => PrivateProjectsIdRoute,
} as any)
const PrivateProjectsIdDataIndexRoute =
  PrivateProjectsIdDataIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateProjectsIdDataRoute,
  } as any)
const PrivateProjectsIdSitesNewRoute =
  PrivateProjectsIdSitesNewRouteImport.update({
    id: '/sites/new',
    path: '/sites/new',
    getParentRoute: () => PrivateProjectsIdRoute,
  } as any)
const PrivateProjectsIdScanTagCodeRoute =
  PrivateProjectsIdScanTagCodeRouteImport.update({
    id: '/scan/$tagCode',
    path: '/scan/$tagCode',
    getParentRoute: () => PrivateProjectsIdRoute,
  } as any)
const PrivateProjectsIdObservationsNewRoute =
  PrivateProjectsIdObservationsNewRouteImport.update({
    id: '/observations/new',
    path: '/observations/new',
    getParentRoute: () => PrivateProjectsIdRoute,
  } as any)
const PrivateProjectsIdGeospatialNewRoute =
  PrivateProjectsIdGeospatialNewRouteImport.update({
    id: '/geospatial/new',
    path: '/geospatial/new',
    getParentRoute: () => PrivateProjectsIdRoute,
  } as any)
const PrivateProjectsIdDataUploadsRoute =
  PrivateProjectsIdDataUploadsRouteImport.update({
    id: '/uploads',
    path: '/uploads',
    getParentRoute: () => PrivateProjectsIdDataRoute,
  } as any)
const PrivateProjectsIdObservationsNewIndexRoute =
  PrivateProjectsIdObservationsNewIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateProjectsIdObservationsNewRoute,
  } as any)
const PrivateProjectsIdDataTracksIndexRoute =
  PrivateProjectsIdDataTracksIndexRouteImport.update({
    id: '/tracks/',
    path: '/tracks/',
    getParentRoute: () => PrivateProjectsIdDataRoute,
  } as any)
const PrivateProjectsIdDataTasksIndexRoute =
  PrivateProjectsIdDataTasksIndexRouteImport.update({
    id: '/tasks/',
    path: '/tasks/',
    getParentRoute: () => PrivateProjectsIdDataRoute,
  } as any)
const PrivateProjectsIdDataSpeciesIndexRoute =
  PrivateProjectsIdDataSpeciesIndexRouteImport.update({
    id: '/species/',
    path: '/species/',
    getParentRoute: () => PrivateProjectsIdDataRoute,
  } as any)
const PrivateProjectsIdDataSitesIndexRoute =
  PrivateProjectsIdDataSitesIndexRouteImport.update({
    id: '/sites/',
    path: '/sites/',
    getParentRoute: () => PrivateProjectsIdDataRoute,
  } as any)
const PrivateProjectsIdDataObservationsIndexRoute =
  PrivateProjectsIdDataObservationsIndexRouteImport.update({
    id: '/observations/',
    path: '/observations/',
    getParentRoute: () => PrivateProjectsIdDataRoute,
  } as any)
const PrivateProjectsIdDataGeospatialIndexRoute =
  PrivateProjectsIdDataGeospatialIndexRouteImport.update({
    id: '/geospatial/',
    path: '/geospatial/',
    getParentRoute: () => PrivateProjectsIdDataRoute,
  } as any)
const PrivateProjectsIdDataContextIndexRoute =
  PrivateProjectsIdDataContextIndexRouteImport.update({
    id: '/context/',
    path: '/context/',
    getParentRoute: () => PrivateProjectsIdDataRoute,
  } as any)
const PrivateProjectsIdSitesSiteIdEditRoute =
  PrivateProjectsIdSitesSiteIdEditRouteImport.update({
    id: '/sites/$siteId/edit',
    path: '/sites/$siteId/edit',
    getParentRoute: () => PrivateProjectsIdRoute,
  } as any)
const PrivateProjectsIdObservationsNewSpeciesRoute =
  PrivateProjectsIdObservationsNewSpeciesRouteImport.update({
    id: '/species',
    path: '/species',
    getParentRoute: () => PrivateProjectsIdObservationsNewRoute,
  } as any)
const PrivateProjectsIdObservationsNewExistingRoute =
  PrivateProjectsIdObservationsNewExistingRouteImport.update({
    id: '/existing',
    path: '/existing',
    getParentRoute: () => PrivateProjectsIdObservationsNewRoute,
  } as any)
const PrivateProjectsIdObservationsNewCollectionRoute =
  PrivateProjectsIdObservationsNewCollectionRouteImport.update({
    id: '/collection',
    path: '/collection',
    getParentRoute: () => PrivateProjectsIdObservationsNewRoute,
  } as any)
const PrivateProjectsIdObservationsObservationIdEditRoute =
  PrivateProjectsIdObservationsObservationIdEditRouteImport.update({
    id: '/observations/$observationId/edit',
    path: '/observations/$observationId/edit',
    getParentRoute: () => PrivateProjectsIdRoute,
  } as any)
const PrivateProjectsIdGeospatialRecordIdEditRoute =
  PrivateProjectsIdGeospatialRecordIdEditRouteImport.update({
    id: '/geospatial/$recordId/edit',
    path: '/geospatial/$recordId/edit',
    getParentRoute: () => PrivateProjectsIdRoute,
  } as any)
const PrivateProjectsIdDataTracksTrackIdRoute =
  PrivateProjectsIdDataTracksTrackIdRouteImport.update({
    id: '/tracks/$trackId',
    path: '/tracks/$trackId',
    getParentRoute: () => PrivateProjectsIdDataRoute,
  } as any)
const PrivateProjectsIdDataSpeciesSpeciesIdRoute =
  PrivateProjectsIdDataSpeciesSpeciesIdRouteImport.update({
    id: '/species/$speciesId',
    path: '/species/$speciesId',
    getParentRoute: () => PrivateProjectsIdDataRoute,
  } as any)
const PrivateProjectsIdDataOfflineMapTilesRoute =
  PrivateProjectsIdDataOfflineMapTilesRouteImport.update({
    id: '/offline/map-tiles',
    path: '/offline/map-tiles',
    getParentRoute: () => PrivateProjectsIdDataRoute,
  } as any)
const PrivateProjectsIdDataGeospatialRecordIdRoute =
  PrivateProjectsIdDataGeospatialRecordIdRouteImport.update({
    id: '/geospatial/$recordId',
    path: '/geospatial/$recordId',
    getParentRoute: () => PrivateProjectsIdDataRoute,
  } as any)
const PrivateProjectsIdDataContextSourceIdRoute =
  PrivateProjectsIdDataContextSourceIdRouteImport.update({
    id: '/context/$sourceId',
    path: '/context/$sourceId',
    getParentRoute: () => PrivateProjectsIdDataRoute,
  } as any)
const PrivateProjectsIdDataSitesSiteIdIndexRoute =
  PrivateProjectsIdDataSitesSiteIdIndexRouteImport.update({
    id: '/sites/$siteId/',
    path: '/sites/$siteId/',
    getParentRoute: () => PrivateProjectsIdDataRoute,
  } as any)
const PrivateProjectsIdDataObservationsObservationIdIndexRoute =
  PrivateProjectsIdDataObservationsObservationIdIndexRouteImport.update({
    id: '/observations/$observationId/',
    path: '/observations/$observationId/',
    getParentRoute: () => PrivateProjectsIdDataRoute,
  } as any)
const PrivateProjectsIdDataContextSpeciesTaxonRoute =
  PrivateProjectsIdDataContextSpeciesTaxonRouteImport.update({
    id: '/context/species/$taxon',
    path: '/context/species/$taxon',
    getParentRoute: () => PrivateProjectsIdDataRoute,
  } as any)
const PrivateProjectsIdDataContextGovernmentLayerIdRoute =
  PrivateProjectsIdDataContextGovernmentLayerIdRouteImport.update({
    id: '/context/government/$layerId',
    path: '/context/government/$layerId',
    getParentRoute: () => PrivateProjectsIdDataRoute,
  } as any)
const PrivateProjectsIdDataContextDocumentDocumentIdRoute =
  PrivateProjectsIdDataContextDocumentDocumentIdRouteImport.update({
    id: '/context/document/$documentId',
    path: '/context/document/$documentId',
    getParentRoute: () => PrivateProjectsIdDataRoute,
  } as any)
const PrivateProjectsIdCollectionsCollectionIdDeterminationsNewRoute =
  PrivateProjectsIdCollectionsCollectionIdDeterminationsNewRouteImport.update({
    id: '/collections/$collectionId/determinations/new',
    path: '/collections/$collectionId/determinations/new',
    getParentRoute: () => PrivateProjectsIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auth': typeof AuthRouteWithChildren
  '/auth/login': typeof AuthLoginRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/reset-password-confirm': typeof AuthResetPasswordConfirmRoute
  '/auth/reset-password-request': typeof AuthResetPasswordRequestRoute
  '/scan/$tagCode': typeof ScanTagCodeRoute
  '/projects/$id': typeof PrivateProjectsIdRouteWithChildren
  '/projects': typeof PrivateProjectsIndexRoute
  '/settings': typeof PrivateSettingsIndexRoute
  '/projects/$id/data': typeof PrivateProjectsIdDataRouteWithChildren
  '/projects/$id/': typeof PrivateProjectsIdIndexRoute
  '/projects/$id/data/uploads': typeof PrivateProjectsIdDataUploadsRoute
  '/projects/$id/geospatial/new': typeof PrivateProjectsIdGeospatialNewRoute
  '/projects/$id/observations/new': typeof PrivateProjectsIdObservationsNewRouteWithChildren
  '/projects/$id/scan/$tagCode': typeof PrivateProjectsIdScanTagCodeRoute
  '/projects/$id/sites/new': typeof PrivateProjectsIdSitesNewRoute
  '/projects/$id/data/': typeof PrivateProjectsIdDataIndexRoute
  '/projects/$id/data/context/$sourceId': typeof PrivateProjectsIdDataContextSourceIdRoute
  '/projects/$id/data/geospatial/$recordId': typeof PrivateProjectsIdDataGeospatialRecordIdRoute
  '/projects/$id/data/offline/map-tiles': typeof PrivateProjectsIdDataOfflineMapTilesRoute
  '/projects/$id/data/species/$speciesId': typeof PrivateProjectsIdDataSpeciesSpeciesIdRoute
  '/projects/$id/data/tracks/$trackId': typeof PrivateProjectsIdDataTracksTrackIdRoute
  '/projects/$id/geospatial/$recordId/edit': typeof PrivateProjectsIdGeospatialRecordIdEditRoute
  '/projects/$id/observations/$observationId/edit': typeof PrivateProjectsIdObservationsObservationIdEditRoute
  '/projects/$id/observations/new/collection': typeof PrivateProjectsIdObservationsNewCollectionRoute
  '/projects/$id/observations/new/existing': typeof PrivateProjectsIdObservationsNewExistingRoute
  '/projects/$id/observations/new/species': typeof PrivateProjectsIdObservationsNewSpeciesRoute
  '/projects/$id/sites/$siteId/edit': typeof PrivateProjectsIdSitesSiteIdEditRoute
  '/projects/$id/data/context': typeof PrivateProjectsIdDataContextIndexRoute
  '/projects/$id/data/geospatial': typeof PrivateProjectsIdDataGeospatialIndexRoute
  '/projects/$id/data/observations': typeof PrivateProjectsIdDataObservationsIndexRoute
  '/projects/$id/data/sites': typeof PrivateProjectsIdDataSitesIndexRoute
  '/projects/$id/data/species': typeof PrivateProjectsIdDataSpeciesIndexRoute
  '/projects/$id/data/tasks': typeof PrivateProjectsIdDataTasksIndexRoute
  '/projects/$id/data/tracks': typeof PrivateProjectsIdDataTracksIndexRoute
  '/projects/$id/observations/new/': typeof PrivateProjectsIdObservationsNewIndexRoute
  '/projects/$id/collections/$collectionId/determinations/new': typeof PrivateProjectsIdCollectionsCollectionIdDeterminationsNewRoute
  '/projects/$id/data/context/document/$documentId': typeof PrivateProjectsIdDataContextDocumentDocumentIdRoute
  '/projects/$id/data/context/government/$layerId': typeof PrivateProjectsIdDataContextGovernmentLayerIdRoute
  '/projects/$id/data/context/species/$taxon': typeof PrivateProjectsIdDataContextSpeciesTaxonRoute
  '/projects/$id/data/observations/$observationId': typeof PrivateProjectsIdDataObservationsObservationIdIndexRoute
  '/projects/$id/data/sites/$siteId': typeof PrivateProjectsIdDataSitesSiteIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth': typeof AuthRouteWithChildren
  '/auth/login': typeof AuthLoginRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/reset-password-confirm': typeof AuthResetPasswordConfirmRoute
  '/auth/reset-password-request': typeof AuthResetPasswordRequestRoute
  '/scan/$tagCode': typeof ScanTagCodeRoute
  '/projects': typeof PrivateProjectsIndexRoute
  '/settings': typeof PrivateSettingsIndexRoute
  '/projects/$id': typeof PrivateProjectsIdIndexRoute
  '/projects/$id/data/uploads': typeof PrivateProjectsIdDataUploadsRoute
  '/projects/$id/geospatial/new': typeof PrivateProjectsIdGeospatialNewRoute
  '/projects/$id/scan/$tagCode': typeof PrivateProjectsIdScanTagCodeRoute
  '/projects/$id/sites/new': typeof PrivateProjectsIdSitesNewRoute
  '/projects/$id/data': typeof PrivateProjectsIdDataIndexRoute
  '/projects/$id/data/context/$sourceId': typeof PrivateProjectsIdDataContextSourceIdRoute
  '/projects/$id/data/geospatial/$recordId': typeof PrivateProjectsIdDataGeospatialRecordIdRoute
  '/projects/$id/data/offline/map-tiles': typeof PrivateProjectsIdDataOfflineMapTilesRoute
  '/projects/$id/data/species/$speciesId': typeof PrivateProjectsIdDataSpeciesSpeciesIdRoute
  '/projects/$id/data/tracks/$trackId': typeof PrivateProjectsIdDataTracksTrackIdRoute
  '/projects/$id/geospatial/$recordId/edit': typeof PrivateProjectsIdGeospatialRecordIdEditRoute
  '/projects/$id/observations/$observationId/edit': typeof PrivateProjectsIdObservationsObservationIdEditRoute
  '/projects/$id/observations/new/collection': typeof PrivateProjectsIdObservationsNewCollectionRoute
  '/projects/$id/observations/new/existing': typeof PrivateProjectsIdObservationsNewExistingRoute
  '/projects/$id/observations/new/species': typeof PrivateProjectsIdObservationsNewSpeciesRoute
  '/projects/$id/sites/$siteId/edit': typeof PrivateProjectsIdSitesSiteIdEditRoute
  '/projects/$id/data/context': typeof PrivateProjectsIdDataContextIndexRoute
  '/projects/$id/data/geospatial': typeof PrivateProjectsIdDataGeospatialIndexRoute
  '/projects/$id/data/observations': typeof PrivateProjectsIdDataObservationsIndexRoute
  '/projects/$id/data/sites': typeof PrivateProjectsIdDataSitesIndexRoute
  '/projects/$id/data/species': typeof PrivateProjectsIdDataSpeciesIndexRoute
  '/projects/$id/data/tasks': typeof PrivateProjectsIdDataTasksIndexRoute
  '/projects/$id/data/tracks': typeof PrivateProjectsIdDataTracksIndexRoute
  '/projects/$id/observations/new': typeof PrivateProjectsIdObservationsNewIndexRoute
  '/projects/$id/collections/$collectionId/determinations/new': typeof PrivateProjectsIdCollectionsCollectionIdDeterminationsNewRoute
  '/projects/$id/data/context/document/$documentId': typeof PrivateProjectsIdDataContextDocumentDocumentIdRoute
  '/projects/$id/data/context/government/$layerId': typeof PrivateProjectsIdDataContextGovernmentLayerIdRoute
  '/projects/$id/data/context/species/$taxon': typeof PrivateProjectsIdDataContextSpeciesTaxonRoute
  '/projects/$id/data/observations/$observationId': typeof PrivateProjectsIdDataObservationsObservationIdIndexRoute
  '/projects/$id/data/sites/$siteId': typeof PrivateProjectsIdDataSitesSiteIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_private': typeof PrivateRouteWithChildren
  '/auth': typeof AuthRouteWithChildren
  '/auth/login': typeof AuthLoginRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/reset-password-confirm': typeof AuthResetPasswordConfirmRoute
  '/auth/reset-password-request': typeof AuthResetPasswordRequestRoute
  '/scan/$tagCode': typeof ScanTagCodeRoute
  '/_private/projects/$id': typeof PrivateProjectsIdRouteWithChildren
  '/_private/projects/': typeof PrivateProjectsIndexRoute
  '/_private/settings/': typeof PrivateSettingsIndexRoute
  '/_private/projects/$id/data': typeof PrivateProjectsIdDataRouteWithChildren
  '/_private/projects/$id/': typeof PrivateProjectsIdIndexRoute
  '/_private/projects/$id/data/uploads': typeof PrivateProjectsIdDataUploadsRoute
  '/_private/projects/$id/geospatial/new': typeof PrivateProjectsIdGeospatialNewRoute
  '/_private/projects/$id/observations/new': typeof PrivateProjectsIdObservationsNewRouteWithChildren
  '/_private/projects/$id/scan/$tagCode': typeof PrivateProjectsIdScanTagCodeRoute
  '/_private/projects/$id/sites/new': typeof PrivateProjectsIdSitesNewRoute
  '/_private/projects/$id/data/': typeof PrivateProjectsIdDataIndexRoute
  '/_private/projects/$id/data/context/$sourceId': typeof PrivateProjectsIdDataContextSourceIdRoute
  '/_private/projects/$id/data/geospatial/$recordId': typeof PrivateProjectsIdDataGeospatialRecordIdRoute
  '/_private/projects/$id/data/offline/map-tiles': typeof PrivateProjectsIdDataOfflineMapTilesRoute
  '/_private/projects/$id/data/species/$speciesId': typeof PrivateProjectsIdDataSpeciesSpeciesIdRoute
  '/_private/projects/$id/data/tracks/$trackId': typeof PrivateProjectsIdDataTracksTrackIdRoute
  '/_private/projects/$id/geospatial/$recordId/edit': typeof PrivateProjectsIdGeospatialRecordIdEditRoute
  '/_private/projects/$id/observations/$observationId/edit': typeof PrivateProjectsIdObservationsObservationIdEditRoute
  '/_private/projects/$id/observations/new/collection': typeof PrivateProjectsIdObservationsNewCollectionRoute
  '/_private/projects/$id/observations/new/existing': typeof PrivateProjectsIdObservationsNewExistingRoute
  '/_private/projects/$id/observations/new/species': typeof PrivateProjectsIdObservationsNewSpeciesRoute
  '/_private/projects/$id/sites/$siteId/edit': typeof PrivateProjectsIdSitesSiteIdEditRoute
  '/_private/projects/$id/data/context/': typeof PrivateProjectsIdDataContextIndexRoute
  '/_private/projects/$id/data/geospatial/': typeof PrivateProjectsIdDataGeospatialIndexRoute
  '/_private/projects/$id/data/observations/': typeof PrivateProjectsIdDataObservationsIndexRoute
  '/_private/projects/$id/data/sites/': typeof PrivateProjectsIdDataSitesIndexRoute
  '/_private/projects/$id/data/species/': typeof PrivateProjectsIdDataSpeciesIndexRoute
  '/_private/projects/$id/data/tasks/': typeof PrivateProjectsIdDataTasksIndexRoute
  '/_private/projects/$id/data/tracks/': typeof PrivateProjectsIdDataTracksIndexRoute
  '/_private/projects/$id/observations/new/': typeof PrivateProjectsIdObservationsNewIndexRoute
  '/_private/projects/$id/collections/$collectionId/determinations/new': typeof PrivateProjectsIdCollectionsCollectionIdDeterminationsNewRoute
  '/_private/projects/$id/data/context/document/$documentId': typeof PrivateProjectsIdDataContextDocumentDocumentIdRoute
  '/_private/projects/$id/data/context/government/$layerId': typeof PrivateProjectsIdDataContextGovernmentLayerIdRoute
  '/_private/projects/$id/data/context/species/$taxon': typeof PrivateProjectsIdDataContextSpeciesTaxonRoute
  '/_private/projects/$id/data/observations/$observationId/': typeof PrivateProjectsIdDataObservationsObservationIdIndexRoute
  '/_private/projects/$id/data/sites/$siteId/': typeof PrivateProjectsIdDataSitesSiteIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/auth/login'
    | '/auth/reset-password'
    | '/auth/reset-password-confirm'
    | '/auth/reset-password-request'
    | '/scan/$tagCode'
    | '/projects/$id'
    | '/projects'
    | '/settings'
    | '/projects/$id/data'
    | '/projects/$id/'
    | '/projects/$id/data/uploads'
    | '/projects/$id/geospatial/new'
    | '/projects/$id/observations/new'
    | '/projects/$id/scan/$tagCode'
    | '/projects/$id/sites/new'
    | '/projects/$id/data/'
    | '/projects/$id/data/context/$sourceId'
    | '/projects/$id/data/geospatial/$recordId'
    | '/projects/$id/data/offline/map-tiles'
    | '/projects/$id/data/species/$speciesId'
    | '/projects/$id/data/tracks/$trackId'
    | '/projects/$id/geospatial/$recordId/edit'
    | '/projects/$id/observations/$observationId/edit'
    | '/projects/$id/observations/new/collection'
    | '/projects/$id/observations/new/existing'
    | '/projects/$id/observations/new/species'
    | '/projects/$id/sites/$siteId/edit'
    | '/projects/$id/data/context'
    | '/projects/$id/data/geospatial'
    | '/projects/$id/data/observations'
    | '/projects/$id/data/sites'
    | '/projects/$id/data/species'
    | '/projects/$id/data/tasks'
    | '/projects/$id/data/tracks'
    | '/projects/$id/observations/new/'
    | '/projects/$id/collections/$collectionId/determinations/new'
    | '/projects/$id/data/context/document/$documentId'
    | '/projects/$id/data/context/government/$layerId'
    | '/projects/$id/data/context/species/$taxon'
    | '/projects/$id/data/observations/$observationId'
    | '/projects/$id/data/sites/$siteId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/auth/login'
    | '/auth/reset-password'
    | '/auth/reset-password-confirm'
    | '/auth/reset-password-request'
    | '/scan/$tagCode'
    | '/projects'
    | '/settings'
    | '/projects/$id'
    | '/projects/$id/data/uploads'
    | '/projects/$id/geospatial/new'
    | '/projects/$id/scan/$tagCode'
    | '/projects/$id/sites/new'
    | '/projects/$id/data'
    | '/projects/$id/data/context/$sourceId'
    | '/projects/$id/data/geospatial/$recordId'
    | '/projects/$id/data/offline/map-tiles'
    | '/projects/$id/data/species/$speciesId'
    | '/projects/$id/data/tracks/$trackId'
    | '/projects/$id/geospatial/$recordId/edit'
    | '/projects/$id/observations/$observationId/edit'
    | '/projects/$id/observations/new/collection'
    | '/projects/$id/observations/new/existing'
    | '/projects/$id/observations/new/species'
    | '/projects/$id/sites/$siteId/edit'
    | '/projects/$id/data/context'
    | '/projects/$id/data/geospatial'
    | '/projects/$id/data/observations'
    | '/projects/$id/data/sites'
    | '/projects/$id/data/species'
    | '/projects/$id/data/tasks'
    | '/projects/$id/data/tracks'
    | '/projects/$id/observations/new'
    | '/projects/$id/collections/$collectionId/determinations/new'
    | '/projects/$id/data/context/document/$documentId'
    | '/projects/$id/data/context/government/$layerId'
    | '/projects/$id/data/context/species/$taxon'
    | '/projects/$id/data/observations/$observationId'
    | '/projects/$id/data/sites/$siteId'
  id:
    | '__root__'
    | '/'
    | '/_private'
    | '/auth'
    | '/auth/login'
    | '/auth/reset-password'
    | '/auth/reset-password-confirm'
    | '/auth/reset-password-request'
    | '/scan/$tagCode'
    | '/_private/projects/$id'
    | '/_private/projects/'
    | '/_private/settings/'
    | '/_private/projects/$id/data'
    | '/_private/projects/$id/'
    | '/_private/projects/$id/data/uploads'
    | '/_private/projects/$id/geospatial/new'
    | '/_private/projects/$id/observations/new'
    | '/_private/projects/$id/scan/$tagCode'
    | '/_private/projects/$id/sites/new'
    | '/_private/projects/$id/data/'
    | '/_private/projects/$id/data/context/$sourceId'
    | '/_private/projects/$id/data/geospatial/$recordId'
    | '/_private/projects/$id/data/offline/map-tiles'
    | '/_private/projects/$id/data/species/$speciesId'
    | '/_private/projects/$id/data/tracks/$trackId'
    | '/_private/projects/$id/geospatial/$recordId/edit'
    | '/_private/projects/$id/observations/$observationId/edit'
    | '/_private/projects/$id/observations/new/collection'
    | '/_private/projects/$id/observations/new/existing'
    | '/_private/projects/$id/observations/new/species'
    | '/_private/projects/$id/sites/$siteId/edit'
    | '/_private/projects/$id/data/context/'
    | '/_private/projects/$id/data/geospatial/'
    | '/_private/projects/$id/data/observations/'
    | '/_private/projects/$id/data/sites/'
    | '/_private/projects/$id/data/species/'
    | '/_private/projects/$id/data/tasks/'
    | '/_private/projects/$id/data/tracks/'
    | '/_private/projects/$id/observations/new/'
    | '/_private/projects/$id/collections/$collectionId/determinations/new'
    | '/_private/projects/$id/data/context/document/$documentId'
    | '/_private/projects/$id/data/context/government/$layerId'
    | '/_private/projects/$id/data/context/species/$taxon'
    | '/_private/projects/$id/data/observations/$observationId/'
    | '/_private/projects/$id/data/sites/$siteId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  PrivateRoute: typeof PrivateRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  ScanTagCodeRoute: typeof ScanTagCodeRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_private': {
      id: '/_private'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PrivateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scan/$tagCode': {
      id: '/scan/$tagCode'
      path: '/scan/$tagCode'
      fullPath: '/scan/$tagCode'
      preLoaderRoute: typeof ScanTagCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/reset-password-request': {
      id: '/auth/reset-password-request'
      path: '/reset-password-request'
      fullPath: '/auth/reset-password-request'
      preLoaderRoute: typeof AuthResetPasswordRequestRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/reset-password-confirm': {
      id: '/auth/reset-password-confirm'
      path: '/reset-password-confirm'
      fullPath: '/auth/reset-password-confirm'
      preLoaderRoute: typeof AuthResetPasswordConfirmRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_private/settings/': {
      id: '/_private/settings/'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof PrivateSettingsIndexRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/projects/': {
      id: '/_private/projects/'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof PrivateProjectsIndexRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/projects/$id': {
      id: '/_private/projects/$id'
      path: '/projects/$id'
      fullPath: '/projects/$id'
      preLoaderRoute: typeof PrivateProjectsIdRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/projects/$id/': {
      id: '/_private/projects/$id/'
      path: '/'
      fullPath: '/projects/$id/'
      preLoaderRoute: typeof PrivateProjectsIdIndexRouteImport
      parentRoute: typeof PrivateProjectsIdRoute
    }
    '/_private/projects/$id/data': {
      id: '/_private/projects/$id/data'
      path: '/data'
      fullPath: '/projects/$id/data'
      preLoaderRoute: typeof PrivateProjectsIdDataRouteImport
      parentRoute: typeof PrivateProjectsIdRoute
    }
    '/_private/projects/$id/data/': {
      id: '/_private/projects/$id/data/'
      path: '/'
      fullPath: '/projects/$id/data/'
      preLoaderRoute: typeof PrivateProjectsIdDataIndexRouteImport
      parentRoute: typeof PrivateProjectsIdDataRoute
    }
    '/_private/projects/$id/sites/new': {
      id: '/_private/projects/$id/sites/new'
      path: '/sites/new'
      fullPath: '/projects/$id/sites/new'
      preLoaderRoute: typeof PrivateProjectsIdSitesNewRouteImport
      parentRoute: typeof PrivateProjectsIdRoute
    }
    '/_private/projects/$id/scan/$tagCode': {
      id: '/_private/projects/$id/scan/$tagCode'
      path: '/scan/$tagCode'
      fullPath: '/projects/$id/scan/$tagCode'
      preLoaderRoute: typeof PrivateProjectsIdScanTagCodeRouteImport
      parentRoute: typeof PrivateProjectsIdRoute
    }
    '/_private/projects/$id/observations/new': {
      id: '/_private/projects/$id/observations/new'
      path: '/observations/new'
      fullPath: '/projects/$id/observations/new'
      preLoaderRoute: typeof PrivateProjectsIdObservationsNewRouteImport
      parentRoute: typeof PrivateProjectsIdRoute
    }
    '/_private/projects/$id/geospatial/new': {
      id: '/_private/projects/$id/geospatial/new'
      path: '/geospatial/new'
      fullPath: '/projects/$id/geospatial/new'
      preLoaderRoute: typeof PrivateProjectsIdGeospatialNewRouteImport
      parentRoute: typeof PrivateProjectsIdRoute
    }
    '/_private/projects/$id/data/uploads': {
      id: '/_private/projects/$id/data/uploads'
      path: '/uploads'
      fullPath: '/projects/$id/data/uploads'
      preLoaderRoute: typeof PrivateProjectsIdDataUploadsRouteImport
      parentRoute: typeof PrivateProjectsIdDataRoute
    }
    '/_private/projects/$id/observations/new/': {
      id: '/_private/projects/$id/observations/new/'
      path: '/'
      fullPath: '/projects/$id/observations/new/'
      preLoaderRoute: typeof PrivateProjectsIdObservationsNewIndexRouteImport
      parentRoute: typeof PrivateProjectsIdObservationsNewRoute
    }
    '/_private/projects/$id/data/tracks/': {
      id: '/_private/projects/$id/data/tracks/'
      path: '/tracks'
      fullPath: '/projects/$id/data/tracks'
      preLoaderRoute: typeof PrivateProjectsIdDataTracksIndexRouteImport
      parentRoute: typeof PrivateProjectsIdDataRoute
    }
    '/_private/projects/$id/data/tasks/': {
      id: '/_private/projects/$id/data/tasks/'
      path: '/tasks'
      fullPath: '/projects/$id/data/tasks'
      preLoaderRoute: typeof PrivateProjectsIdDataTasksIndexRouteImport
      parentRoute: typeof PrivateProjectsIdDataRoute
    }
    '/_private/projects/$id/data/species/': {
      id: '/_private/projects/$id/data/species/'
      path: '/species'
      fullPath: '/projects/$id/data/species'
      preLoaderRoute: typeof PrivateProjectsIdDataSpeciesIndexRouteImport
      parentRoute: typeof PrivateProjectsIdDataRoute
    }
    '/_private/projects/$id/data/sites/': {
      id: '/_private/projects/$id/data/sites/'
      path: '/sites'
      fullPath: '/projects/$id/data/sites'
      preLoaderRoute: typeof PrivateProjectsIdDataSitesIndexRouteImport
      parentRoute: typeof PrivateProjectsIdDataRoute
    }
    '/_private/projects/$id/data/observations/': {
      id: '/_private/projects/$id/data/observations/'
      path: '/observations'
      fullPath: '/projects/$id/data/observations'
      preLoaderRoute: typeof PrivateProjectsIdDataObservationsIndexRouteImport
      parentRoute: typeof PrivateProjectsIdDataRoute
    }
    '/_private/projects/$id/data/geospatial/': {
      id: '/_private/projects/$id/data/geospatial/'
      path: '/geospatial'
      fullPath: '/projects/$id/data/geospatial'
      preLoaderRoute: typeof PrivateProjectsIdDataGeospatialIndexRouteImport
      parentRoute: typeof PrivateProjectsIdDataRoute
    }
    '/_private/projects/$id/data/context/': {
      id: '/_private/projects/$id/data/context/'
      path: '/context'
      fullPath: '/projects/$id/data/context'
      preLoaderRoute: typeof PrivateProjectsIdDataContextIndexRouteImport
      parentRoute: typeof PrivateProjectsIdDataRoute
    }
    '/_private/projects/$id/sites/$siteId/edit': {
      id: '/_private/projects/$id/sites/$siteId/edit'
      path: '/sites/$siteId/edit'
      fullPath: '/projects/$id/sites/$siteId/edit'
      preLoaderRoute: typeof PrivateProjectsIdSitesSiteIdEditRouteImport
      parentRoute: typeof PrivateProjectsIdRoute
    }
    '/_private/projects/$id/observations/new/species': {
      id: '/_private/projects/$id/observations/new/species'
      path: '/species'
      fullPath: '/projects/$id/observations/new/species'
      preLoaderRoute: typeof PrivateProjectsIdObservationsNewSpeciesRouteImport
      parentRoute: typeof PrivateProjectsIdObservationsNewRoute
    }
    '/_private/projects/$id/observations/new/existing': {
      id: '/_private/projects/$id/observations/new/existing'
      path: '/existing'
      fullPath: '/projects/$id/observations/new/existing'
      preLoaderRoute: typeof PrivateProjectsIdObservationsNewExistingRouteImport
      parentRoute: typeof PrivateProjectsIdObservationsNewRoute
    }
    '/_private/projects/$id/observations/new/collection': {
      id: '/_private/projects/$id/observations/new/collection'
      path: '/collection'
      fullPath: '/projects/$id/observations/new/collection'
      preLoaderRoute: typeof PrivateProjectsIdObservationsNewCollectionRouteImport
      parentRoute: typeof PrivateProjectsIdObservationsNewRoute
    }
    '/_private/projects/$id/observations/$observationId/edit': {
      id: '/_private/projects/$id/observations/$observationId/edit'
      path: '/observations/$observationId/edit'
      fullPath: '/projects/$id/observations/$observationId/edit'
      preLoaderRoute: typeof PrivateProjectsIdObservationsObservationIdEditRouteImport
      parentRoute: typeof PrivateProjectsIdRoute
    }
    '/_private/projects/$id/geospatial/$recordId/edit': {
      id: '/_private/projects/$id/geospatial/$recordId/edit'
      path: '/geospatial/$recordId/edit'
      fullPath: '/projects/$id/geospatial/$recordId/edit'
      preLoaderRoute: typeof PrivateProjectsIdGeospatialRecordIdEditRouteImport
      parentRoute: typeof PrivateProjectsIdRoute
    }
    '/_private/projects/$id/data/tracks/$trackId': {
      id: '/_private/projects/$id/data/tracks/$trackId'
      path: '/tracks/$trackId'
      fullPath: '/projects/$id/data/tracks/$trackId'
      preLoaderRoute: typeof PrivateProjectsIdDataTracksTrackIdRouteImport
      parentRoute: typeof PrivateProjectsIdDataRoute
    }
    '/_private/projects/$id/data/species/$speciesId': {
      id: '/_private/projects/$id/data/species/$speciesId'
      path: '/species/$speciesId'
      fullPath: '/projects/$id/data/species/$speciesId'
      preLoaderRoute: typeof PrivateProjectsIdDataSpeciesSpeciesIdRouteImport
      parentRoute: typeof PrivateProjectsIdDataRoute
    }
    '/_private/projects/$id/data/offline/map-tiles': {
      id: '/_private/projects/$id/data/offline/map-tiles'
      path: '/offline/map-tiles'
      fullPath: '/projects/$id/data/offline/map-tiles'
      preLoaderRoute: typeof PrivateProjectsIdDataOfflineMapTilesRouteImport
      parentRoute: typeof PrivateProjectsIdDataRoute
    }
    '/_private/projects/$id/data/geospatial/$recordId': {
      id: '/_private/projects/$id/data/geospatial/$recordId'
      path: '/geospatial/$recordId'
      fullPath: '/projects/$id/data/geospatial/$recordId'
      preLoaderRoute: typeof PrivateProjectsIdDataGeospatialRecordIdRouteImport
      parentRoute: typeof PrivateProjectsIdDataRoute
    }
    '/_private/projects/$id/data/context/$sourceId': {
      id: '/_private/projects/$id/data/context/$sourceId'
      path: '/context/$sourceId'
      fullPath: '/projects/$id/data/context/$sourceId'
      preLoaderRoute: typeof PrivateProjectsIdDataContextSourceIdRouteImport
      parentRoute: typeof PrivateProjectsIdDataRoute
    }
    '/_private/projects/$id/data/sites/$siteId/': {
      id: '/_private/projects/$id/data/sites/$siteId/'
      path: '/sites/$siteId'
      fullPath: '/projects/$id/data/sites/$siteId'
      preLoaderRoute: typeof PrivateProjectsIdDataSitesSiteIdIndexRouteImport
      parentRoute: typeof PrivateProjectsIdDataRoute
    }
    '/_private/projects/$id/data/observations/$observationId/': {
      id: '/_private/projects/$id/data/observations/$observationId/'
      path: '/observations/$observationId'
      fullPath: '/projects/$id/data/observations/$observationId'
      preLoaderRoute: typeof PrivateProjectsIdDataObservationsObservationIdIndexRouteImport
      parentRoute: typeof PrivateProjectsIdDataRoute
    }
    '/_private/projects/$id/data/context/species/$taxon': {
      id: '/_private/projects/$id/data/context/species/$taxon'
      path: '/context/species/$taxon'
      fullPath: '/projects/$id/data/context/species/$taxon'
      preLoaderRoute: typeof PrivateProjectsIdDataContextSpeciesTaxonRouteImport
      parentRoute: typeof PrivateProjectsIdDataRoute
    }
    '/_private/projects/$id/data/context/government/$layerId': {
      id: '/_private/projects/$id/data/context/government/$layerId'
      path: '/context/government/$layerId'
      fullPath: '/projects/$id/data/context/government/$layerId'
      preLoaderRoute: typeof PrivateProjectsIdDataContextGovernmentLayerIdRouteImport
      parentRoute: typeof PrivateProjectsIdDataRoute
    }
    '/_private/projects/$id/data/context/document/$documentId': {
      id: '/_private/projects/$id/data/context/document/$documentId'
      path: '/context/document/$documentId'
      fullPath: '/projects/$id/data/context/document/$documentId'
      preLoaderRoute: typeof PrivateProjectsIdDataContextDocumentDocumentIdRouteImport
      parentRoute: typeof PrivateProjectsIdDataRoute
    }
    '/_private/projects/$id/collections/$collectionId/determinations/new': {
      id: '/_private/projects/$id/collections/$collectionId/determinations/new'
      path: '/collections/$collectionId/determinations/new'
      fullPath: '/projects/$id/collections/$collectionId/determinations/new'
      preLoaderRoute: typeof PrivateProjectsIdCollectionsCollectionIdDeterminationsNewRouteImport
      parentRoute: typeof PrivateProjectsIdRoute
    }
  }
}

interface PrivateProjectsIdDataRouteChildren {
  PrivateProjectsIdDataUploadsRoute: typeof PrivateProjectsIdDataUploadsRoute
  PrivateProjectsIdDataIndexRoute: typeof PrivateProjectsIdDataIndexRoute
  PrivateProjectsIdDataContextSourceIdRoute: typeof PrivateProjectsIdDataContextSourceIdRoute
  PrivateProjectsIdDataGeospatialRecordIdRoute: typeof PrivateProjectsIdDataGeospatialRecordIdRoute
  PrivateProjectsIdDataOfflineMapTilesRoute: typeof PrivateProjectsIdDataOfflineMapTilesRoute
  PrivateProjectsIdDataSpeciesSpeciesIdRoute: typeof PrivateProjectsIdDataSpeciesSpeciesIdRoute
  PrivateProjectsIdDataTracksTrackIdRoute: typeof PrivateProjectsIdDataTracksTrackIdRoute
  PrivateProjectsIdDataContextIndexRoute: typeof PrivateProjectsIdDataContextIndexRoute
  PrivateProjectsIdDataGeospatialIndexRoute: typeof PrivateProjectsIdDataGeospatialIndexRoute
  PrivateProjectsIdDataObservationsIndexRoute: typeof PrivateProjectsIdDataObservationsIndexRoute
  PrivateProjectsIdDataSitesIndexRoute: typeof PrivateProjectsIdDataSitesIndexRoute
  PrivateProjectsIdDataSpeciesIndexRoute: typeof PrivateProjectsIdDataSpeciesIndexRoute
  PrivateProjectsIdDataTasksIndexRoute: typeof PrivateProjectsIdDataTasksIndexRoute
  PrivateProjectsIdDataTracksIndexRoute: typeof PrivateProjectsIdDataTracksIndexRoute
  PrivateProjectsIdDataContextDocumentDocumentIdRoute: typeof PrivateProjectsIdDataContextDocumentDocumentIdRoute
  PrivateProjectsIdDataContextGovernmentLayerIdRoute: typeof PrivateProjectsIdDataContextGovernmentLayerIdRoute
  PrivateProjectsIdDataContextSpeciesTaxonRoute: typeof PrivateProjectsIdDataContextSpeciesTaxonRoute
  PrivateProjectsIdDataObservationsObservationIdIndexRoute: typeof PrivateProjectsIdDataObservationsObservationIdIndexRoute
  PrivateProjectsIdDataSitesSiteIdIndexRoute: typeof PrivateProjectsIdDataSitesSiteIdIndexRoute
}

const PrivateProjectsIdDataRouteChildren: PrivateProjectsIdDataRouteChildren = {
  PrivateProjectsIdDataUploadsRoute: PrivateProjectsIdDataUploadsRoute,
  PrivateProjectsIdDataIndexRoute: PrivateProjectsIdDataIndexRoute,
  PrivateProjectsIdDataContextSourceIdRoute:
    PrivateProjectsIdDataContextSourceIdRoute,
  PrivateProjectsIdDataGeospatialRecordIdRoute:
    PrivateProjectsIdDataGeospatialRecordIdRoute,
  PrivateProjectsIdDataOfflineMapTilesRoute:
    PrivateProjectsIdDataOfflineMapTilesRoute,
  PrivateProjectsIdDataSpeciesSpeciesIdRoute:
    PrivateProjectsIdDataSpeciesSpeciesIdRoute,
  PrivateProjectsIdDataTracksTrackIdRoute:
    PrivateProjectsIdDataTracksTrackIdRoute,
  PrivateProjectsIdDataContextIndexRoute:
    PrivateProjectsIdDataContextIndexRoute,
  PrivateProjectsIdDataGeospatialIndexRoute:
    PrivateProjectsIdDataGeospatialIndexRoute,
  PrivateProjectsIdDataObservationsIndexRoute:
    PrivateProjectsIdDataObservationsIndexRoute,
  PrivateProjectsIdDataSitesIndexRoute: PrivateProjectsIdDataSitesIndexRoute,
  PrivateProjectsIdDataSpeciesIndexRoute:
    PrivateProjectsIdDataSpeciesIndexRoute,
  PrivateProjectsIdDataTasksIndexRoute: PrivateProjectsIdDataTasksIndexRoute,
  PrivateProjectsIdDataTracksIndexRoute: PrivateProjectsIdDataTracksIndexRoute,
  PrivateProjectsIdDataContextDocumentDocumentIdRoute:
    PrivateProjectsIdDataContextDocumentDocumentIdRoute,
  PrivateProjectsIdDataContextGovernmentLayerIdRoute:
    PrivateProjectsIdDataContextGovernmentLayerIdRoute,
  PrivateProjectsIdDataContextSpeciesTaxonRoute:
    PrivateProjectsIdDataContextSpeciesTaxonRoute,
  PrivateProjectsIdDataObservationsObservationIdIndexRoute:
    PrivateProjectsIdDataObservationsObservationIdIndexRoute,
  PrivateProjectsIdDataSitesSiteIdIndexRoute:
    PrivateProjectsIdDataSitesSiteIdIndexRoute,
}

const PrivateProjectsIdDataRouteWithChildren =
  PrivateProjectsIdDataRoute._addFileChildren(
    PrivateProjectsIdDataRouteChildren,
  )

interface PrivateProjectsIdObservationsNewRouteChildren {
  PrivateProjectsIdObservationsNewCollectionRoute: typeof PrivateProjectsIdObservationsNewCollectionRoute
  PrivateProjectsIdObservationsNewExistingRoute: typeof PrivateProjectsIdObservationsNewExistingRoute
  PrivateProjectsIdObservationsNewSpeciesRoute: typeof PrivateProjectsIdObservationsNewSpeciesRoute
  PrivateProjectsIdObservationsNewIndexRoute: typeof PrivateProjectsIdObservationsNewIndexRoute
}

const PrivateProjectsIdObservationsNewRouteChildren: PrivateProjectsIdObservationsNewRouteChildren =
  {
    PrivateProjectsIdObservationsNewCollectionRoute:
      PrivateProjectsIdObservationsNewCollectionRoute,
    PrivateProjectsIdObservationsNewExistingRoute:
      PrivateProjectsIdObservationsNewExistingRoute,
    PrivateProjectsIdObservationsNewSpeciesRoute:
      PrivateProjectsIdObservationsNewSpeciesRoute,
    PrivateProjectsIdObservationsNewIndexRoute:
      PrivateProjectsIdObservationsNewIndexRoute,
  }

const PrivateProjectsIdObservationsNewRouteWithChildren =
  PrivateProjectsIdObservationsNewRoute._addFileChildren(
    PrivateProjectsIdObservationsNewRouteChildren,
  )

interface PrivateProjectsIdRouteChildren {
  PrivateProjectsIdDataRoute: typeof PrivateProjectsIdDataRouteWithChildren
  PrivateProjectsIdIndexRoute: typeof PrivateProjectsIdIndexRoute
  PrivateProjectsIdGeospatialNewRoute: typeof PrivateProjectsIdGeospatialNewRoute
  PrivateProjectsIdObservationsNewRoute: typeof PrivateProjectsIdObservationsNewRouteWithChildren
  PrivateProjectsIdScanTagCodeRoute: typeof PrivateProjectsIdScanTagCodeRoute
  PrivateProjectsIdSitesNewRoute: typeof PrivateProjectsIdSitesNewRoute
  PrivateProjectsIdGeospatialRecordIdEditRoute: typeof PrivateProjectsIdGeospatialRecordIdEditRoute
  PrivateProjectsIdObservationsObservationIdEditRoute: typeof PrivateProjectsIdObservationsObservationIdEditRoute
  PrivateProjectsIdSitesSiteIdEditRoute: typeof PrivateProjectsIdSitesSiteIdEditRoute
  PrivateProjectsIdCollectionsCollectionIdDeterminationsNewRoute: typeof PrivateProjectsIdCollectionsCollectionIdDeterminationsNewRoute
}

const PrivateProjectsIdRouteChildren: PrivateProjectsIdRouteChildren = {
  PrivateProjectsIdDataRoute: PrivateProjectsIdDataRouteWithChildren,
  PrivateProjectsIdIndexRoute: PrivateProjectsIdIndexRoute,
  PrivateProjectsIdGeospatialNewRoute: PrivateProjectsIdGeospatialNewRoute,
  PrivateProjectsIdObservationsNewRoute:
    PrivateProjectsIdObservationsNewRouteWithChildren,
  PrivateProjectsIdScanTagCodeRoute: PrivateProjectsIdScanTagCodeRoute,
  PrivateProjectsIdSitesNewRoute: PrivateProjectsIdSitesNewRoute,
  PrivateProjectsIdGeospatialRecordIdEditRoute:
    PrivateProjectsIdGeospatialRecordIdEditRoute,
  PrivateProjectsIdObservationsObservationIdEditRoute:
    PrivateProjectsIdObservationsObservationIdEditRoute,
  PrivateProjectsIdSitesSiteIdEditRoute: PrivateProjectsIdSitesSiteIdEditRoute,
  PrivateProjectsIdCollectionsCollectionIdDeterminationsNewRoute:
    PrivateProjectsIdCollectionsCollectionIdDeterminationsNewRoute,
}

const PrivateProjectsIdRouteWithChildren =
  PrivateProjectsIdRoute._addFileChildren(PrivateProjectsIdRouteChildren)

interface PrivateRouteChildren {
  PrivateProjectsIdRoute: typeof PrivateProjectsIdRouteWithChildren
  PrivateProjectsIndexRoute: typeof PrivateProjectsIndexRoute
  PrivateSettingsIndexRoute: typeof PrivateSettingsIndexRoute
}

const PrivateRouteChildren: PrivateRouteChildren = {
  PrivateProjectsIdRoute: PrivateProjectsIdRouteWithChildren,
  PrivateProjectsIndexRoute: PrivateProjectsIndexRoute,
  PrivateSettingsIndexRoute: PrivateSettingsIndexRoute,
}

const PrivateRouteWithChildren =
  PrivateRoute._addFileChildren(PrivateRouteChildren)

interface AuthRouteChildren {
  AuthLoginRoute: typeof AuthLoginRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthResetPasswordConfirmRoute: typeof AuthResetPasswordConfirmRoute
  AuthResetPasswordRequestRoute: typeof AuthResetPasswordRequestRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLoginRoute: AuthLoginRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthResetPasswordConfirmRoute: AuthResetPasswordConfirmRoute,
  AuthResetPasswordRequestRoute: AuthResetPasswordRequestRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  PrivateRoute: PrivateRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  ScanTagCodeRoute: ScanTagCodeRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
